import { FC } from "react";
import { RecallPermissionKind } from "@/modules/electron/types";
import { useSystemPermissionHandlers } from "@/components/desktop/system-permissions/shared";
import { PermissionStatusMap } from "@/components/desktop/system-permissions/shared/system-permissions.types";
import { VoicePermissionsModalContent } from "@/components/desktop/system-permissions/voice/voice-permissions-modal-content";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  permissionStatusMap: PermissionStatusMap;
  onRestart: () => void;
  onRequestPermission: (permission: RecallPermissionKind) => Promise<void>;
  onOpenPermissionPane: (permission: RecallPermissionKind) => Promise<void>;
};

export const VoicePermissionsModal: FC<Props> = ({
  isOpen,
  onClose,
  permissionStatusMap,
  onRestart,
  onRequestPermission,
  onOpenPermissionPane,
}: Props) => {
  const {
    resolveConfigurationStatus,
    handleEnablePermission,
    handleOpenPermissionPane,
    restartRequired,
  } = useSystemPermissionHandlers({
    onRequestPermission,
    onOpenPermissionPane,
    permissionStatusMap,
  });

  return (
    <VoicePermissionsModalContent
      isOpen={isOpen}
      onClose={onClose}
      resolveConfigurationStatus={resolveConfigurationStatus}
      handleEnablePermission={handleEnablePermission}
      handleOpenPermissionPane={handleOpenPermissionPane}
      restartRequired={restartRequired}
      onRestart={onRestart}
    />
  );
};
